/* src/app/shared/components/login-failed/login-failed.component.scss */
.login-failed-title {
  margin: 1rem 0;
  text-align: center;
}
/*# sourceMappingURL=login-failed.component.css.map */
